import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import App from './App';
import { inicializarTenant } from './lib/tenant';
import { inicializarCapturaInstall } from './lib/pwa-kiosk';

// Resolve o tenant antes do React montar — garante que qualquer chamada RTK
// Query já enviará o header `X-Tenant` com o valor correto.
inicializarTenant();
// Captura cedo o convite de instalação do PWA (o navegador não mostra o convite
// nativo); só é oferecido, via botão, no modo tablet/totem.
inicializarCapturaInstall();

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

function removerSplash(): void {
  const splash = document.getElementById('splash-inicial')
  if (!splash) return

  splash.classList.add('saindo')
  setTimeout(() => splash.remove(), 250)
}

requestAnimationFrame(() => requestAnimationFrame(removerSplash))
